<router-outlet></router-outlet>
<div class="header-container">
  <app-view-gallery-header
    class="dark"
    [gallery]="gallery"
    [accessLevel]="accessLevel"
    [mode]="'advanced'"
  ></app-view-gallery-header>
</div>
<app-advanced-mode
  [gallery]="gallery"
  [assets]="assets"
  [sections]="sections"
  [clientMode]="true"
  [blockShortcuts]="onAssetPage"
></app-advanced-mode>
